var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RestServiceBase } from '@ane/core/lib/services/RestServiceBase';
import { onError } from '@ane/core/lib/decorators/OnError';
import { getFlightQueryParams, constructQueryString } from '../../../utils/FlightRoute.utils';
import EnvironmentService from '@ane/core/lib/services/EnvironmentService';
class FlightResource extends RestServiceBase {
    constructor() {
        super(EnvironmentService.endpoints.legacy, '/api');
        this._errorMessage = (RestResult, response) => {
            return response && response.ExceptionMessage;
        };
    }
    _v2APIPath(tenantId) {
        return `/2.0/tenants/${tenantId}/flights/`;
    }
    loadFlightTreatmentVariablesV2(flightId, workspaceId, managementGroup, tenant) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryString = constructQueryString(getFlightQueryParams(managementGroup, workspaceId));
            const address = `${this._v2APIPath(tenant)}${flightId}/variables${queryString}`;
            const result = yield this._get(address);
            return result.getSuccessData(this._errorMessage);
        });
    }
    // BCT makes a second API call to this /Flight/Overview. There is some data displayed on the flight page
    // that can only be retrieved from this API call. (e.g. ResaltSeed,g Flight Group, state, etc).
    loadFlightOverview(flightId, workspaceId, managementGroup) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = [`flightName=${flightId}`, ...getFlightQueryParams(managementGroup, workspaceId)];
            const queryString = constructQueryString(params);
            const address = `/flight/overview/${queryString}`;
            return yield this._get(address);
        });
    }
    loadFlightTraffic(flightId_1, managementGroup_1, workspaceId_1) {
        return __awaiter(this, arguments, void 0, function* (flightId, managementGroup, workspaceId, skipIndirectTraffic = true) {
            const params = [
                `flightName=${flightId}`,
                `skipIndirectTraffic=${skipIndirectTraffic}`,
                ...getFlightQueryParams(managementGroup, workspaceId),
            ];
            const queryString = constructQueryString(params);
            const address = `/flight/traffic/${queryString}`;
            const result = yield this._get(address);
            return result.getSuccessData(this._errorMessage);
        });
    }
    updateFlight(flightId, workspaceId, managementGroup, tenant, flightConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryString = constructQueryString(getFlightQueryParams(managementGroup, workspaceId));
            const address = `${this._v2APIPath(tenant)}${flightId}${queryString}`;
            const result = yield this._put(flightConfig, address);
            return result.ensureSuccess(this._errorMessage);
        });
    }
    createFlights(tenant, workspaceId, flightConfigurations) {
        return __awaiter(this, void 0, void 0, function* () {
            const address = `${this._v2APIPath(tenant)}batch?workspaceId=${workspaceId}`;
            const result = yield this._post(flightConfigurations, address);
            return result;
        });
    }
}
__decorate([
    onError({ message: `An error occurred.` })
], FlightResource.prototype, "loadFlightTreatmentVariablesV2", null);
__decorate([
    onError({ message: `An error occurred.` })
], FlightResource.prototype, "loadFlightOverview", null);
__decorate([
    onError({ message: `An error occured when loading flight traffic.` })
], FlightResource.prototype, "loadFlightTraffic", null);
export default new FlightResource();

//# sourceMappingURL=Flight.resource.js.map
